var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotipoBrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 416,
    viewBox: "0 0 287 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.999 0H32.0111C25.6947 11.2644 12.1789 35.483 8.64667 42.2416C4.23135 50.69 0 58.22 0 66.6683C0 73.427 3.80208 81.8508 5.70312 85.2179L71.381 197.25H206.6C181.764 159.477 131.282 82.463 128.044 76.5859C124.806 70.7088 127.308 63.4849 128.964 60.6076L162.999 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.615 220.024H80.0276C104.128 256.633 153.396 331.505 157.664 338.117C161.932 344.728 160.914 350.177 159.871 352.075L124.549 415.07H256.089C263.325 402.03 278.202 375.106 279.821 371.726C281.845 367.502 286.812 359.605 286.996 350.606C287.143 343.406 283.255 334.872 281.293 331.505L215.615 220.024Z",
    fill: "#3700FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipoBrk);
export default __webpack_public_path__ + "static/media/logotipo_BRK.300e7365cb804a4a0a1052a3691112e3.svg";
export { ForwardRef as ReactComponent };